// eslint-disable-next-line no-use-before-define
var site = window.site || {};

site.userInfoCookie = site.userInfoCookie || {};
site.userInfoCookie.getValue =
  site.userInfoCookie.getValue ||
  function () {
    return '';
  };
(function ($) {
  Drupal.behaviors.loyaltyDynamicJoinFormV1 = {
    attach: function (context) {
      var signedIn = Number(site.userInfoCookie.getValue('signed_in'));
      var isLoyalty = Number(site.userInfoCookie.getValue('pure_priv_num'));
      const guest = $('.js-guest', context);
      const loggedIn = $('.js-logged-in-non-loyalty', context);
      const loggedInLoyalty = $('.js-logged-in-loyalty', context);

      if (signedIn && isLoyalty) {
        guest.addClass('hidden');
        loggedIn.addClass('hidden');
        loggedInLoyalty.removeClass('hidden');
      } else if (signedIn && !isLoyalty) {
        guest.addClass('hidden');
        loggedInLoyalty.addClass('hidden');
        loggedIn.removeClass('hidden');
      } else {
        loggedInLoyalty.addClass('hidden');
        loggedIn.addClass('hidden');
        guest.removeClass('hidden');
      }
    }
  };
})(jQuery);
